<template>
  <div class="m-list">
    <div class="width-a">
      <h1 class="title">教学管理</h1>
      <ul class="type">
        <template v-for="(item, index) in types">
          <li :class="typeIndex == index ? 'type-b' : 'type-a'" :key="item.typeId" @click="typeTap(index)">{{item.name}}
          </li>
        </template>
      </ul>
      <ul class="content">
        <router-view></router-view>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ManageEducation",
    data () {
      return {
        types: [
          {
            name: "我的课表",
            path: "/ManageEducation/TeacherSchedule"
          },
          // {
          //   name: "题库管理",
          //   path: "/ManageEducation/QuestionDepository"
          // },
          // {
          //   name: "考核管理",
          //   path: "/ManageEducation/AssessmentDepository"
          // },
          {
            name: "学员成绩",
            path: "/ManageEducation/AssessmentScore"
          },
          {
            name: "我的班级",
            path: "/ManageEducation/TeacherClass"
          },
          // {
          //   name: "课程管理",
          //   path: "/ManageEducation/ManageCourse"
          // },
        ],
        typeIndex: 0
      }
    },
    methods: {
      typeTap (index) {
        this.typeIndex = index;
        let _path = this.types[index].path;
        this.$router.push({
          path: _path
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .m-list {
    background-image: url("../../assets/bga01.png");
    background-repeat: no-repeat;
    min-height: 590px;
  }

  .title {
    font-size: 36px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
    padding: 80px 0px 50px 0px;
  }

  .type {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .type-a {
      width: 160px;
      height: 56px;
      text-align: center;
      line-height: 56px;
      background-color: #395bcd;
      color: #ffffff;
      font-size: 18px;
      margin: 0px 16px;
      cursor: pointer;
    }

    .type-b {
      width: 160px;
      height: 56px;
      text-align: center;
      line-height: 56px;
      background-color: #253b85;
      color: #ffffff;
      font-size: 18px;
      margin: 0px 16px;
      cursor: pointer;
    }
  }

  .content {
    padding: 60px 60px 60px 60px;
    margin-top: 60px;
    background-color: #ffffff;
  }
</style>